// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__VIrxN","inner":"Form_inner__2xLCK","range":"Form_range__hUk1a","name":"Form_name__2QSl9","actions":"Form_actions__1VbMZ"};